<template>
    <div class="flex flex-wrap gap-x-4 gap-y-2 items-center">
        <div v-for="(label, i) in items" :key="i" class="flex items-center gap-2">
            <span class="inline-block w-3 h-3 rounded-sm" :class="paletteColor(i, items.length)"></span>
            <span class="details text-ink-muted">{{ label }}</span>
        </div>
    </div>
</template>

<script setup lang="ts">
import { computed } from "vue";

import { paletteColor } from "./distributionPalette";

interface Props {
    maxScore: number;
    labels?: string[];
}

const props = defineProps<Props>();

const items = computed<string[]>(() => {
    if (props.labels && props.labels.length === props.maxScore) {
        return props.labels.map((label, i) => `${i + 1} · ${label}`);
    }
    return Array.from({ length: props.maxScore }, (_, i) => String(i + 1));
});
</script>
